export default __webpack_public_path__ + "locales/el-GR/SharingPanel.json?hash=f7887b62fbb6427aeb56d2120fc25ece";